var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgHeartBroken = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 28 28",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "m14.693 6.527-2.529 3.896 2.494 4.279-2.494 4.279 2.102 7.653L4.109 16.4c-2.815-2.836-2.81-7.44 0-10.27a7.16 7.16 0 0 1 10.19 0zm2.887-.28.113-.114a7.174 7.174 0 0 1 10.194-.003 7.295 7.295 0 0 1-.003 10.272l-5.092 5.132-5.596 5.638-2.347-8.191 2.685-4.076-2.876-4.482z"
  })));
};
export default SvgHeartBroken;